// extracted by mini-css-extract-plugin
export default {"container":"Wn-z","bubbleNav":"Xn-z","graphic":"Yn-z","contact":"Zn-z"};